import { Variant } from "../../types/types";

export const getVariantDimensions = (sizeVariant: Variant) => {
  // @ts-ignore
  const variantDimensions = sizeVariant.attributes?.find(
    // @ts-ignore
    (attribute) => attribute.displayName === "Dimensions",
  )?.values;

  if (variantDimensions && variantDimensions[0]) {
    if (sizeVariant?.differentiators?.size !== variantDimensions[0]) {
      return `(${variantDimensions[0]})`;
    }
  }

  return;
};
